import React from 'react'

import LinkComponent from '../LinkComponent/LinkComponent'
import {
  ctaButton,
  primary,
  secondary,
  teritiary,
  transparent,
  wideBtn,
} from './CtaButton.module.css'

const CtaButton = ({
  cardWrappedwithLink,
  className,
  dest,
  extraClassName,
  lang,
  link,
  newCta,
  onClick,
  target,
  title,
  type,
  url,
  wide,
}) => {
  let finalLink = url || link
  if (dest === 'email') {
    finalLink = `mailto:${target}`
  }
  if (dest === 'phone') {
    finalLink = `tel:${target}`
  }
  if (dest === 'internal') {
    finalLink = `${target}`
  }

  const getTypeClass = (buttonType) => {
    switch (buttonType) {
      case 'primary':
        return primary
      case 'secondary':
        return secondary
      case 'transparent':
        return transparent
      default:
        return teritiary
    }
  }

  if (newCta) {
    return (
      <a
        className={`${ctaButton} ${getTypeClass(type)} ${className} ${
          wide ? wideBtn : ''
        } ${extraClassName || ''}`}
        href="https://schedule.clinicminds.com/?location=66397588-e4d4-11e3-991e-0655abbdc0b4"
        rel="noreferrer"
        target="_blank"
      >
        {lang === 'en' ? 'Book treatment' : 'Plan Behandeling'}
      </a>
    )
  }

  if (cardWrappedwithLink) {
    return (
      <p
        className={`${ctaButton} ${getTypeClass(type)} ${className} ${
          wide ? wideBtn : ''
        } ${extraClassName || ''}`}
      >
        {title}
      </p>
    )
  }

  if (onClick) {
    return (
      <button
        className={`${ctaButton} ${getTypeClass(type)} ${className} ${
          wide ? wideBtn : ''
        } ${extraClassName || ''}`}
        onClick={onClick}
        type="button"
      >
        {title}
      </button>
    )
  }

  return (
    <LinkComponent
      className={`${ctaButton} ${getTypeClass(type)} ${className} ${
        wide ? wideBtn : ''
      } ${extraClassName || ''}`}
      dest={dest}
      src={finalLink}
    >
      {title}
    </LinkComponent>
  )
}

export default CtaButton
